import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TestsRequests from "services/tests";
import { fetchError, fetchSuccess } from "redux/actions";
import { makeStyles } from "@material-ui/core/styles";
import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import GridContainer from "@jumbo/components/GridContainer";
import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@material-ui/core";
import TestQuestionElement from "./TestQuestion";
import QuestionFooter from "../compnents/QuestionFooter";
import AddQuesitonDialog from "../compnents/AddQuesitonDialog";
import RemoveQuesitonDialog from "../compnents/RemoveQuestionDialog";
import UpdateQuesitonDialog from "../compnents/UpdateQuestionDialog";
import TestImageQuestionElement from "./TestImageQuesiton";
import RangeQuestionElment from "./RangeQuestion";
import PuzzleQuestionElment from "./PuzzleQuestion";
import ConnectingQuestionElement from "./ConnectingQuestion";
import SortingQuestionElement from "./SortingQuestion";
import DifferenceQuestionElement from "./DiffrenceQuestion";
import FileUploadQuestionElement from "./FileUpload";
import GuessWordQuestionElement from "./WordGame";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Checkbox, FormControlLabel } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  titleText: {
    fontSize: 20,
    fontWeight: "bold",
    color: theme.palette.primary.main,
    marginBottom: 16,
  },
  formControl: {
    width: "100%",
    marginInline: "auto",
    marginTop: 20,
  },
}));

function CreateQuestion({ question, quizId }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [questionType, setQuestionType] = useState("multipleChoice");
  // dialog states
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);

  // questionStates
  const [questoinTitle, setQuestoinTitle] = useState("");
  const [cover, setCover] = useState("");
  const [score, setScore] = useState(10);
  const [exposed, setExposed] = useState(false);
  const [firstOption, setfirstOption] = useState("");
  const [secondOption, setSecondOption] = useState("");
  const [thirdOption, setThirdOption] = useState("");
  const [forthOption, setForthOption] = useState("");
  const [correctOption, setCorrectOption] = useState("");

  // rangeQuestionStates
  const [minRange, setMinRange] = useState(0);
  const [maxRange, setMaxRange] = useState(0);
  const [minRangeAnswer, setMinRangeAnswer] = useState(0);
  const [maxRangeAnswer, setMaxRangeAnswer] = useState(0);
  const [stepSizeRange, setStepSizeRange] = useState(1);

  // puzzleQuesitonStates
  const [puzzleSource, setPuzzleSource] = useState("");
  const [puzzleRow, setPuzzleRow] = useState(0);
  const [puzzleColumn, setPuzzleColumn] = useState(0);

  // connectingQuestionStates
  const [rightSideItems, setRightSideItems] = useState([]);
  const [leftSideItems, setLeftSideItems] = useState([]);

  // sortingQuestionStates
  const [sortingItems, setSortingItems] = useState([]);

  // fileUploadStates
  const [files, setFiles] = useState([]);

  // Guess word States
  const [wordAnswer, setWordAnswer] = useState("");
  const [wordTryCount, setWordTryCount] = useState(0);

  const setQuestion = () => {
    setQuestionType(question.type);
    setQuestoinTitle(question.title);
    setScore(question.score);
    setCover(question?.cover);
    setExposed(question?.exposed);
    setfirstOption(question?.optionA);
    setSecondOption(question?.optionB);
    setThirdOption(question?.optionC);
    setForthOption(question?.optionD);
    setCorrectOption(question?.optionAnswer);
    setMinRange(question?.minRange);
    setMaxRange(question?.maxRange);
    setMinRangeAnswer(question?.minRangeAnswer);
    setMaxRangeAnswer(question?.maxRangeAnswer);
    setStepSizeRange(question?.stepSizeRange);
    setPuzzleSource(question?.puzzleSource);
    setPuzzleRow(question?.puzzleRow);
    setPuzzleColumn(question?.puzzleColumn);
    setRightSideItems(
      question?.optionsConnecting
        ? question.optionsConnecting.map((item) => item.split("|")[0])
        : []
    );
    setLeftSideItems(
      question?.optionsConnecting
        ? question.optionsConnecting.map((item) => item.split("|")[1])
        : []
    );
    setSortingItems(question?.optionsSorting ? question.optionsSorting : []);
    setFiles(question?.files ? question.files : []);
    setWordAnswer(question?.wordAnswer);
    setWordTryCount(question?.wordTryCount);
  };

  useEffect(() => {
    if (question) {
      setQuestion();
    }
  }, [question]);

  useEffect(() => {
    scoreSetter();
  }, [questionType]);

  const scoreSetter = () => {
    if (!question) {
      if (questionType === "multipleChoice") {
        setScore(10);
      } else if (questionType === "multipleImageChoice") {
        setScore(9);
      } else if (questionType === "range") {
        setScore(11);
      } else if (questionType === "puzzle") {
        setScore(15);
      } else if (questionType === "connecting") {
        setScore(14);
      } else if (questionType === "sorting") {
        setScore(12);
      } else if (questionType === "file") {
        setScore(110);
      } else if (questionType === "wordgame") {
        setScore(20);
      }
    }
  };

  let questionContainer = null;
  if (questionType === "multipleChoice") {
    questionContainer = (
      <TestQuestionElement
        questoinTitle={questoinTitle}
        setQuestoinTitle={setQuestoinTitle}
        cover={cover}
        setCover={setCover}
        score={score}
        setScore={setScore}
        correctOption={correctOption}
        setCorrectOption={setCorrectOption}
        firstOption={firstOption}
        setfirstOption={setfirstOption}
        secondOption={secondOption}
        setSecondOption={setSecondOption}
        thirdOption={thirdOption}
        setThirdOption={setThirdOption}
        forthOption={forthOption}
        setForthOption={setForthOption}
      />
    );
  } else if (questionType === "multipleImageChoice") {
    questionContainer = (
      <TestImageQuestionElement
        questoinTitle={questoinTitle}
        setQuestoinTitle={setQuestoinTitle}
        cover={cover}
        setCover={setCover}
        score={score}
        setScore={setScore}
        correctOption={correctOption}
        setCorrectOption={setCorrectOption}
        firstOption={firstOption}
        setfirstOption={setfirstOption}
        secondOption={secondOption}
        setSecondOption={setSecondOption}
        thirdOption={thirdOption}
        setThirdOption={setThirdOption}
        forthOption={forthOption}
        setForthOption={setForthOption}
      />
    );
  } else if (questionType === "range") {
    questionContainer = (
      <RangeQuestionElment
        questoinTitle={questoinTitle}
        setQuestoinTitle={setQuestoinTitle}
        cover={cover}
        setCover={setCover}
        score={score}
        setScore={setScore}
        minRange={minRange}
        setMinRange={setMinRange}
        maxRange={maxRange}
        setMaxRange={setMaxRange}
        minRangeAnswer={minRangeAnswer}
        setMinRangeAnswer={setMinRangeAnswer}
        maxRangeAnswer={maxRangeAnswer}
        setMaxRangeAnswer={setMaxRangeAnswer}
        stepSizeRange={stepSizeRange}
        setStepSizeRange={setStepSizeRange}
      />
    );
  } else if (questionType === "puzzle") {
    questionContainer = (
      <PuzzleQuestionElment
        questoinTitle={questoinTitle}
        setQuestoinTitle={setQuestoinTitle}
        cover={cover}
        setCover={setCover}
        score={score}
        setScore={setScore}
        puzzleSource={puzzleSource}
        setPuzzleSource={setPuzzleSource}
        puzzleRow={puzzleRow}
        setPuzzleRow={setPuzzleRow}
        puzzleColumn={puzzleColumn}
        setPuzzleColumn={setPuzzleColumn}
      />
    );
  } else if (questionType === "connecting") {
    questionContainer = (
      <ConnectingQuestionElement
        questoinTitle={questoinTitle}
        setQuestoinTitle={setQuestoinTitle}
        cover={cover}
        setCover={setCover}
        score={score}
        setScore={setScore}
        rightSideItems={rightSideItems}
        setRightSideItems={setRightSideItems}
        leftSideItems={leftSideItems}
        setLeftSideItems={setLeftSideItems}
      />
    );
  } else if (questionType === "sorting") {
    questionContainer = (
      <SortingQuestionElement
        questoinTitle={questoinTitle}
        setQuestoinTitle={setQuestoinTitle}
        cover={cover}
        setCover={setCover}
        score={score}
        setScore={setScore}
        sortingItems={sortingItems}
        setSortingItems={setSortingItems}
      />
    );
  } else if (questionType === "file") {
    questionContainer = (
      <FileUploadQuestionElement
        questoinTitle={questoinTitle}
        setQuestoinTitle={setQuestoinTitle}
        cover={cover}
        setCover={setCover}
        score={score}
        setScore={setScore}
        files={files}
        setFiles={setFiles}
      />
    );
  } else if (questionType === "wordgame") {
    questionContainer = (
      <GuessWordQuestionElement
        questoinTitle={questoinTitle}
        setQuestoinTitle={setQuestoinTitle}
        cover={cover}
        setCover={setCover}
        score={score}
        setScore={setScore}
        wordAnswer={wordAnswer}
        setWordAnswer={setWordAnswer}
        wordTryCount={wordTryCount}
        setWordTryCount={setWordTryCount}
      />
    );
  } else if (questionType === "difference") {
    questionContainer = (
      <DifferenceQuestionElement question={question} quizId={quizId} />
    );
  }

  const handleAddQuesiton = () => {
    let QusetionData = {
      difficulty: "common",
      cover: cover,
      score: score,
      exposed: exposed,
      title: questoinTitle,
      type: questionType,
      quizId: quizId,
    };
    if (
      questionType === "multipleChoice" ||
      questionType === "multipleImageChoice"
    ) {
      QusetionData["optionA"] = firstOption;
      QusetionData["optionB"] = secondOption;
      QusetionData["optionC"] = thirdOption;
      QusetionData["optionD"] = forthOption;
      QusetionData["optionAnswer"] = correctOption;
      if (
        !questoinTitle ||
        !firstOption ||
        !secondOption ||
        !thirdOption ||
        !forthOption ||
        !correctOption
      ) {
        dispatch(fetchError("وارد کردن تمامی موارد الزامی میباشد!!!"));
        setOpenAddDialog(false);
      } else {
        dispatch(TestsRequests.addSingleQuestion(QusetionData))
          .then(() => {
            resetState();
          })
          .catch((err) => {
            dispatch(fetchError(err));
          });
        setOpenAddDialog(false);
      }
    } else if (questionType === "range") {
      QusetionData["minRange"] = minRange;
      QusetionData["maxRange"] = maxRange;
      QusetionData["minRangeAnswer"] = minRangeAnswer;
      QusetionData["maxRangeAnswer"] = maxRangeAnswer;
      QusetionData["stepSizeRange"] = stepSizeRange;
      if (!questoinTitle) {
        dispatch(fetchError("وارد کردن تمامی موارد الزامی میباشد!!!"));
        setOpenAddDialog(false);
      } else {
        dispatch(TestsRequests.addSingleQuestion(QusetionData))
          .then(() => {
            resetState();
          })
          .catch((err) => {
            dispatch(fetchError(err));
          });
        setOpenAddDialog(false);
      }
    } else if (questionType === "puzzle") {
      QusetionData["puzzleSource"] = puzzleSource;
      QusetionData["puzzleRow"] = puzzleRow;
      QusetionData["puzzleColumn"] = puzzleColumn;
      if (!questoinTitle || !puzzleSource || !puzzleRow || !puzzleColumn) {
        dispatch(fetchError("وارد کردن تمامی موارد الزامی میباشد!!!"));
        setOpenAddDialog(false);
      } else {
        dispatch(TestsRequests.addSingleQuestion(QusetionData))
          .then(() => {
            resetState();
          })
          .catch((err) => {
            dispatch(fetchError(err));
          });
        setOpenAddDialog(false);
      }
    } else if (questionType === "connecting") {
      if (!questoinTitle || rightSideItems.length === 0) {
        dispatch(fetchError("وارد کردن تمامی موارد الزامی میباشد!!!"));
        setOpenAddDialog(false);
      } else if (rightSideItems.length !== leftSideItems.length) {
        dispatch(fetchError("تعداد موارد در دوطرف یکسان نیست"));
        setOpenAddDialog(false);
      } else {
        QusetionData["optionsConnecting"] = rightSideItems.map(
          (item, index) => `${rightSideItems[index]}|${leftSideItems[index]}`
        );
        dispatch(TestsRequests.addSingleQuestion(QusetionData))
          .then(() => {
            resetState();
          })
          .catch((err) => {
            dispatch(fetchError(err));
          });
        setOpenAddDialog(false);
      }
    } else if (questionType === "sorting") {
      QusetionData["optionsSorting"] = sortingItems;
      if (!questoinTitle || sortingItems.length === 0) {
        dispatch(fetchError("وارد کردن تمامی موارد الزامی میباشد!!!"));
        setOpenAddDialog(false);
      } else {
        dispatch(TestsRequests.addSingleQuestion(QusetionData))
          .then(() => {
            resetState();
          })
          .catch((err) => {
            dispatch(fetchError(err));
          });
        setOpenAddDialog(false);
      }
    } else if (questionType === "file") {
      QusetionData["files"] = files;
      if (!files || files.length === 0) {
        dispatch(fetchError("وارد کردن تمامی موارد الزامی میباشد!!!"));
        setOpenAddDialog(false);
      } else {
        dispatch(TestsRequests.addSingleQuestion(QusetionData))
          .then(() => {
            resetState();
          })
          .catch((err) => {
            dispatch(fetchError(err));
          });
        setOpenAddDialog(false);
      }
    } else if (questionType === "wordgame") {
      QusetionData["wordAnswer"] = wordAnswer;
      QusetionData["wordTryCount"] = wordTryCount;
      if (!wordAnswer || !wordTryCount) {
        dispatch(fetchError("وارد کردن تمامی موارد الزامی میباشد!!!"));
        setOpenAddDialog(false);
      } else {
        dispatch(TestsRequests.addSingleQuestion(QusetionData))
          .then(() => {
            resetState();
          })
          .catch((err) => {
            dispatch(fetchError(err));
          });
        setOpenAddDialog(false);
      }
    }
  };

  const handleEditAndClose = () => {
    let QusetionData = {
      difficulty: "common",
      cover: cover,
      score: score,
      exposed: exposed,
      title: questoinTitle,
      type: questionType,
      quizId: quizId,
    };
    if (
      questionType === "multipleChoice" ||
      questionType === "multipleImageChoice"
    ) {
      QusetionData["optionA"] = firstOption;
      QusetionData["optionB"] = secondOption;
      QusetionData["optionC"] = thirdOption;
      QusetionData["optionD"] = forthOption;
      QusetionData["optionAnswer"] = correctOption;
      dispatch(TestsRequests.updateSingleQuestion(question._id, QusetionData));
      setOpenUpdateDialog(false);
    } else if (questionType === "range") {
      QusetionData["minRange"] = minRange;
      QusetionData["maxRange"] = maxRange;
      QusetionData["minRangeAnswer"] = minRangeAnswer;
      QusetionData["maxRangeAnswer"] = maxRangeAnswer;
      QusetionData["stepSizeRange"] = stepSizeRange;
      dispatch(TestsRequests.updateSingleQuestion(question._id, QusetionData));
      setOpenUpdateDialog(false);
    } else if (questionType === "puzzle") {
      QusetionData["puzzleSource"] = puzzleSource;
      QusetionData["puzzleRow"] = puzzleRow;
      QusetionData["puzzleColumn"] = puzzleColumn;
      dispatch(TestsRequests.updateSingleQuestion(question._id, QusetionData));
      setOpenUpdateDialog(false);
    } else if (questionType === "connecting") {
      if (rightSideItems.length !== leftSideItems.length) {
        dispatch(fetchError("تعداد موارد در دوطرف یکسان نیست"));
      } else {
        QusetionData["optionsConnecting"] = rightSideItems.map(
          (item, index) => `${rightSideItems[index]}|${leftSideItems[index]}`
        );
      }
      dispatch(TestsRequests.updateSingleQuestion(question._id, QusetionData));
      setOpenUpdateDialog(false);
    } else if (questionType === "sorting") {
      if (sortingItems.lenght === 0) {
        dispatch(fetchError("موارد نمیتواند خالی باشد"));
      } else {
        QusetionData["optionsSorting"] = sortingItems;
      }
      dispatch(TestsRequests.updateSingleQuestion(question._id, QusetionData));
      setOpenUpdateDialog(false);
    } else if (questionType === "file") {
      if (files.lenght === 0) {
        dispatch(fetchError("موارد نمیتواند خالی باشد"));
      } else {
        QusetionData["files"] = files;
      }
      dispatch(TestsRequests.updateSingleQuestion(question._id, QusetionData));
      setOpenUpdateDialog(false);
    } else if (questionType === "wordgame") {
      if (!wordAnswer || !wordTryCount) {
        dispatch(fetchError("موارد نمیتواند خالی باشد"));
      } else {
        QusetionData["wordAnswer"] = wordAnswer;
        QusetionData["wordTryCount"] = wordTryCount;
      }
      dispatch(TestsRequests.updateSingleQuestion(question._id, QusetionData));
      setOpenUpdateDialog(false);
    }
  };

  const handleRemoveAndClose = () => {
    dispatch(TestsRequests.removeSingleQuestion(question._id));
    setOpenRemoveDialog(false);
  };

  const resetState = () => {
    setQuestoinTitle("");
    setCover("");
    setExposed(false);
    scoreSetter();
    if (
      questionType === "multipleChoice" ||
      questionType === "multipleImageChoice"
    ) {
      setfirstOption("");
      setSecondOption("");
      setThirdOption("");
      setForthOption("");
      setCorrectOption("");
    } else if (questionType === "range") {
      setMinRange(0);
      setMaxRange(0);
      setMinRangeAnswer(0);
      setMaxRangeAnswer(0);
      setStepSizeRange(1);
    } else if (questionType === "puzzle") {
      setPuzzleSource("");
      setPuzzleRow(0);
      setPuzzleColumn(0);
    } else if (questionType === "connecting") {
      setRightSideItems([]);
      setLeftSideItems([]);
    } else if (questionType === "sorting") {
      setSortingItems([]);
    } else if (questionType === "file") {
      setFiles([]);
    } else if (questionType === "wordgame") {
      setWordAnswer("");
      setWordTryCount(0);
    }
  };

  const handleCopy = () => {
    const data = {
      questionType: questionType,
      questoinTitle: questoinTitle,
      cover: cover,
      score: score,
      exposed: exposed,
      firstOption: firstOption,
      secondOption: secondOption,
      thirdOption: thirdOption,
      forthOption: forthOption,
      correctOption: correctOption,
      minRange: minRange,
      maxRange: maxRange,
      minRangeAnswer: minRangeAnswer,
      maxRangeAnswer: maxRangeAnswer,
      stepSizeRange: stepSizeRange,
      puzzleSource: puzzleSource,
      puzzleRow: puzzleRow,
      puzzleColumn: puzzleColumn,
      rightSideItems: rightSideItems,
      leftSideItems: leftSideItems,
      sortingItems: sortingItems,
      files: files,
      wordAnswer: wordAnswer,
      wordTryCount: wordTryCount,
    };

    const fromattedData = Object.entries(data)
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n");
    navigator.clipboard
      .writeText(fromattedData)
      .then(() => {
        dispatch(fetchSuccess("باموفقیت کپی شد"));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      const lines = text.split("\n");
      const newFormData = {};
      lines.forEach((line) => {
        const [key, ...rest] = line.split(":");
        if (key && rest.length > 0) {
          newFormData[key.trim()] = rest.join(":").trim();
        }
      });
      if (newFormData.questionType) {
        setQuestionType(newFormData.questionType);
        setQuestoinTitle(newFormData.questoinTitle);
        setCover(newFormData.cover);
        setScore(newFormData.score);
        setExposed(newFormData.exposed);
        if (
          newFormData.questionType === "multipleChoice" ||
          newFormData.questionType === "multipleImageChoice"
        ) {
          setfirstOption(newFormData.firstOption);
          setSecondOption(newFormData.secondOption);
          setThirdOption(newFormData.thirdOption);
          setForthOption(newFormData.forthOption);
          setCorrectOption(newFormData.correctOption);
        } else if (newFormData.questionType === "range") {
          setMinRange(newFormData.minRange);
          setMaxRange(newFormData.maxRange);
          setMinRangeAnswer(newFormData.minRangeAnswer);
          setMaxRangeAnswer(newFormData.maxRangeAnswer);
          setStepSizeRange(newFormData.stepSizeRange);
        } else if (newFormData.questionType === "puzzle") {
          setPuzzleSource(newFormData.puzzleSource);
          setPuzzleRow(newFormData.puzzleRow);
          setPuzzleColumn(newFormData.puzzleColumn);
        } else if (newFormData.questionType === "connecting") {
          setRightSideItems(newFormData.rightSideItems.split(","));
          setLeftSideItems(newFormData.leftSideItems.split(","));
        } else if (newFormData.questionType === "sorting") {
          setSortingItems(newFormData.sortingItems.split(","));
        } else if (newFormData.questionType === "file") {
          setFiles(newFormData.files.split(","));
        } else if (newFormData.questionType === "wordgame") {
          setWordAnswer(newFormData.wordAnswer);
          setWordTryCount(newFormData.wordTryCount);
        }
      }
      // alert("Form data pasted from clipboard!");
    } catch (err) {
      console.error("Failed to read from clipboard: ", err);
    }
  };

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent>
            <GridContainer>
              <Grid item xs={12}>
                <Tooltip title="copy to clipboard">
                  <IconButton aria-label="copy" onClick={handleCopy}>
                    <FileCopyIcon fontSize="medium" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="paste clipboard">
                  <IconButton aria-label="paste" onClick={handlePaste}>
                    <GetAppIcon fontSize="medium" />
                  </IconButton>
                </Tooltip>
              </Grid>
              {!question && (
                <Grid item xs={12}>
                  <Typography className={classes.titleText}>
                    نوع سوال را انتخاب کنید
                  </Typography>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="question-Type-Label">
                      انتخاب نوع سوال
                    </InputLabel>
                    <Select
                      labelId="question-Type-Label"
                      id="question-Type-outlined"
                      value={questionType}
                      onChange={(e) => setQuestionType(e.target.value)}
                      label="انتخاب نوع سوال"
                    >
                      <MenuItem value={"multipleChoice"}>تستی</MenuItem>
                      <MenuItem value={"multipleImageChoice"}>
                        تستی تصویری
                      </MenuItem>
                      <MenuItem value={"range"}>طیفی</MenuItem>
                      <MenuItem value={"puzzle"}>پازل</MenuItem>
                      <MenuItem value={"sorting"}>مرتب کردن</MenuItem>
                      <MenuItem value={"difference"}>کشف تفاوت</MenuItem>
                      <MenuItem value={"connecting"}>وصل کردن</MenuItem>
                      <MenuItem value={"file"}>آپلود فایل</MenuItem>
                      {/* <MenuItem value={"wordgame"}>کلمه بازی</MenuItem> */}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {questionContainer}
              {questionType !== "difference" && (
                <Grid item xs={12} style={{ marginTop: "16px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={exposed}
                        onChange={(e) => setExposed(e.target.checked)}
                        color="primary"
                      />
                    }
                    label="لو رفته"
                  />
                </Grid>
              )}
            </GridContainer>
          </CmtCardContent>
          {questionType !== "difference" && (
            <QuestionFooter
              question={question}
              handleAdd={() => setOpenAddDialog(true)}
              handleRemove={() => setOpenRemoveDialog(true)}
              handleUpdate={() => setOpenUpdateDialog(true)}
            />
          )}
        </CmtCard>
      </div>
      <AddQuesitonDialog
        open={openAddDialog}
        handleClose={() => setOpenAddDialog(false)}
        action={handleAddQuesiton}
      />
      <RemoveQuesitonDialog
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleRemoveAndClose}
      />
      <UpdateQuesitonDialog
        open={openUpdateDialog}
        handleClose={() => setOpenUpdateDialog(false)}
        action={handleEditAndClose}
      />
    </React.Fragment>
  );
}

export default CreateQuestion;
